// extracted by mini-css-extract-plugin
export default {"main":"ScrollToTop_main__OfAl-","iconBackground":"ScrollToTop_iconBackground__VP-HN","visible":"ScrollToTop_visible__SbHf6"};